<!--
 * @Description: 服务宣传语
 * @Author: sunhuihong
 * @Date: 2022-05-26 15:43:52
 * @LastEditTime: 2022-11-01 12:57:42
-->
<template>
   <div class="slogan-cfg-body">
    <el-row :gutter="12">
      <el-col :span="8" >
        <el-card class="box-card" shadow="never" :body-style="{padding: '0px',}">
          <div class="box-card-left-main">
            <div class="box-card-header">
              <span style="font-weight: bold">{{sloganCfgData.title}}</span>
              <img src="@/assets/hsvccfg/add-plus.png"  style="float: right; width: 15px; padding-top: 15px;"  
                @click="handleAddSloganCfg"  alt="" />
            </div>
            <el-table style="background-color: #FAFBFF; height: 260px; overflow-y: auto; overflow-x: hidden;" 
              :data="sloganCfgData.sloganCfgList" :show-header="false" :highlight-current-row="true" 
              :row-class-name="tableRowClassNameOfSloganCfg"  @cell-mouse-enter="handleMouseEnterSloganCfg" 
              @cell-mouse-leave="handleMouseLeaveSloganCfg" >
              <el-table-column prop="text" label="" min-width="60%" >
                <template slot-scope="scope">
                  <div style="margin-left: 18px;">{{ scope.row.text }}</div>
                </template>
              </el-table-column>
              <el-table-column align="right" min-width="40%">
                <template slot-scope="scope" v-if="indexSelectSloganCfg == scope.row.index">
                  <img width="16px" height="16px" class="img-edit " src="@/assets/syscfg/icon-usercfg-edit.png"
                    @click="handleEditSloganCfg(scope.$index, scope.row)" alt=""/>
                  <img width="16px" height="16px" class="img-delete " src="@/assets/syscfg/icon-usercfg-delete.png"
                    @click="handleDeleteSloganCfg(scope.$index, scope.row)" alt=""/>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "SloganCfg",
  props: ["sloganCfgData",],
  data() {
    return {
      indexSelectSloganCfg: -1, //当前选中的服务宣传语标签下标
    };
  },

  methods: {
    tableRowClassNameOfSloganCfg({ row,rowIndex }) {
      row.index = rowIndex;
    },

    handleMouseEnterSloganCfg(row, _column, _event) {
      this.indexSelectSloganCfg = row.index;
    },

    handleMouseLeaveSloganCfg(_row, _column, _event) {
      this.indexSelectSloganCfg = -1;
    },

    //新增服务宣传语
    handleAddSloganCfg() {
      this.$emit("add-slogan-cfg");
    },

    //编辑服务宣传语
    handleEditSloganCfg(_index, row) {
      this.$emit("edit-slogan-cfg", row);
    },
    
    //删除服务宣传语
    handleDeleteSloganCfg(_index, row) {
      this.$emit("delete-slogan-cfg", row);
    },
  },
};
</script>

<style>
.slogan-cfg-body {
  margin: 0;
  margin-top: 25px;
  text-align: left;
  border: solid 0px;
}

.slogan-cfg-body .el-card {
  border: 1px solid #DCDDE0;
}

.slogan-cfg-body .box-card-header {
  height: 50px;
	line-height: 50px;
	background-color: white;
	border-bottom: 1px solid #DCDDE0;
  padding: 0px 18px; 
}

.slogan-cfg-body .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
	border: none;
}

.slogan-cfg-body .el-table .cell {
  padding: 0;
}

.slogan-cfg-body .el-table th, .el-table tr {
  background-color: #FAFBFF;
}

.img-edit {
	margin: 0 15px 0 0;
  cursor: pointer;
}

.img-delete {
	margin: 0px 25px 0 0;
  cursor: pointer;
}

.slogan-cfg-body .el-table::before {
	height: 0px;
}

.slogan-cfg-body ::-webkit-scrollbar {
	width: 0px !important;/* 可以滚动，且滚动条不显示； */
}


</style>



// WEBPACK FOOTER //
// src/components/hsvccfg/components/SloganCfg.vue